import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import BaseWholesaleController from "./BaseWholesaleController";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import Logger from "../../common/utils/Logger";
import { fetchDids } from "../../api/did";
import { parseUrlParam } from "../../common/utils/ControllerUtils";
import NtListHeader from "../../components/NtListHeader";
import NtListEmpty from "../../components/NtListEmpty";
import didcsvcolumndata from "../data/didcsvcolumndata";
import NtLoadMoreButton from "../../components/NtLoadMoreButton";
import NtDidItem from "../components/NtDidItem";
import NtListRecordsTitle from "../../components/NtListRecordsTitle";
import settings from "../../config/settings";

class DidController extends BaseWholesaleController {
  state = {
    ...super.state,
    loading: false,
    data: [],
    totalItems: 0,
    searchText: "",
    searchFilter: null,
  };

  column_location = "@did_column_storage";

  page = 1;

  componentDidMount() {
    this.didFocusListener = this.props.navigation.addListener(
      "focus",
      this.handleFocus
    );

    this.handleDefaultColumnsFetch(
      this.column_location,
      didcsvcolumndata.filter((each) => each.default == true)
    );

    this.handleDataFetch();
  }

  componentDidUpdate(prevProps) {
    // Check if the params have changed
    if (prevProps.route.params !== this.props.route.params) {
      this.page = 1;
      this.handleDataFetch();
    }
  }

  componentWillUnmount() {
    // Remove the event listener
    this.didFocusListener();
  }

  handleFocus = () => {
    Logger("DID Controller focused params:", this.props.route);
  };

  handleDataFetch = async () => {
    Logger("Fetching Dids data");

    this.setState({ loading: true });

    const deviceId = parseUrlParam(this.props.route?.params?.deviceid);
    const response = await fetchDids(
      this.context.user?.user?.id,
      deviceId,
      this.page,
      settings.pageSizeLoad
    );

    Logger("Data response GET: ", response);

    if (response.ok) {
      if (this.page == 1) {
        Logger("Loading for the first time.");
        this.setState({
          data: response.data?._embedded?.dids,
          totalItems: response.data?.total_items,
        });
      } else {
        Logger("Loading more.");

        this.setState({
          data: this.state.data.concat(response.data?._embedded?.dids),
        });
      }
    }
    this.setState({ loading: false });
  };

  handleSearch = (text) => {
    this.state.searchText = text;
    this.setState({ searchText: this.state.searchText });
    this.page = 1;
    this.handleDataFetch();
  };

  renderRow = (item, index) => {
    return <NtDidItem key={index} item={item} columns={this.state.columns} />;
  };

  render() {
    return (
      <NtRootPageContainer
        style={styles.container}
        pageTitle={"Phone Numbers"}
        setSearchText={(text) => {
          this.handleSearch(text);
        }}
      >
        <View
          style={{ flexDirection: "row", alignItems: "center", marginTop: 15 }}
        >
          <NtListRecordsTitle count={this.state.totalItems} />
        </View>
        <View
          style={{
            flex: 1,
            marginTop: 15,
          }}
        >
          <NtListHeader
            visible={this.state.data?.length > 0}
            columns={didcsvcolumndata}
            selectedColumns={this.state.columns}
            onColumnUpdate={(updated) => {
              asyncStorageSetData(this.column_location, updated);
              this.setState({ columns: updated });
            }}
            exportFileName={"extension"}
            exportDataParser={this.handleExportDataParce}
            exportFetchDataAsync={this.handleExportFetch}
          />

          <NtListEmpty
            message="No phone numbers found"
            visible={this.state.data?.length == 0}
          />
          {this.state.data.map((each, index) => this.renderRow(each, index))}

          <NtLoadMoreButton
            loadingText={"Loading"}
            title="Load More Extensions"
            loading={this.state.loading}
            containerStyle={{ marginTop: 40, marginBottom: 40 }}
            onPress={() => {
              this.page = this.page + 1;
              this.handleDataFetch();
            }}
          />
        </View>
      </NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default DidController;
